import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import OfferDocument from "@/components/OfferDocument";
import { BonsaiMonogram } from "@/components/BonsaiLogo";

export default function PublicOffer() {
  const { token } = useParams();
  const [offer, setOffer] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public/offers/${token}`);
        setOffer(data);
      } catch {
        setNotFound(true);
      }
    })();
  }, [token]);

  if (notFound)
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-secondary text-center p-6">
        <BonsaiMonogram size={56} />
        <p className="mt-4 text-navy font-bold text-lg">Offerta non trovata</p>
        <p className="text-muted-foreground text-sm">Il link potrebbe essere scaduto o non valido.</p>
      </div>
    );

  if (!offer)
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary">
        <div className="animate-pulse"><BonsaiMonogram size={56} /></div>
      </div>
    );

  return (
    <div className="min-h-screen bg-secondary py-8 px-4">
      <div className="max-w-5xl mx-auto bg-white border border-border rounded-2xl p-6 md:p-12 shadow-sm">
        <OfferDocument offer={offer} />
      </div>
    </div>
  );
}
